export const AMAZON_STORE_LINK =
  "https://www.amazon.de/-/en/gp/aw/d/3756888487/ref=tmm_hrd_swatch_0?ie=UTF8&qid=1673946426&sr=8-4";
export const AUTHOR_PROFILE_LINK = "https://monty.de/";
export const ABOUT_LCX_LINK = "https://www.lcx.com/about/";
export const YOUTUBE_LINK = "https://youtu.be/QgYGeGH4SWY";
